/* eslint-disable react/no-danger */
/* eslint-disable camelcase */
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import ReactTimeAgo from 'react-time-ago';
import PropTypes from 'prop-types';

// app: components
import Heading from 'components/Heading';

// app: props
import CommentProps from './CommentProps';

// assets
import CssComment from './Comment.scss';

const NoteComment = props => {
  const { onEdit } = props;
  useStyles(CssComment);
  const { safe_html, updated_at } = props.comment;

  return (
    <div className="margin-top-10">
      <div
        className=" note comment comment--clickable"
        role="button"
        onKeyDown={onEdit}
        onClick={onEdit}
        tabIndex="0"
      >
        <header className="note__heading">
          <Heading>My notes</Heading>
        </header>
        <div
          className="comment__content"
          dangerouslySetInnerHTML={{
            __html: safe_html,
          }}
        />
      </div>
      {updated_at ? (
        <div className="comment__header__item comment__created note__time">
          updated&nbsp;
          <ReactTimeAgo date={new Date(updated_at)} locale="en-US" />
        </div>
      ) : null}
    </div>
  );
};

NoteComment.propTypes = {
  comment: CommentProps.isRequired,
  onEdit: PropTypes.func,
};

NoteComment.defaultProps = {
  onEdit: () => {},
};

export default React.memo(NoteComment);
